import { useRef } from 'react';
import type { ReactElement, ReactNode } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import styles from './ModalTransition.module.scss';

const transitionClassNames = {
  appear: styles.fadeAppear,
  appearActive: styles.fadeAppearActive,
  enter: styles.fadeEnter,
  enterActive: styles.fadeEnterActive,
  exit: 'leave'
};

type ModalTransitionProps = {
  children: ReactNode;
};

const ModalTransition = ({
  children
}: ModalTransitionProps): ReactElement | null => {
  // children isn't guaranteed to forward refs to a DOM node (e.g. class
  // components don't), so CSSTransition transitions a div we render and
  // ref ourselves, rather than cloning children to attach a ref to it.
  const nodeRef = useRef<HTMLDivElement>(null);

  if (!children) {
    return null;
  }

  return (
    <TransitionGroup component={null}>
      <CSSTransition
        nodeRef={nodeRef}
        timeout={250}
        appear
        enter
        exit={false}
        classNames={transitionClassNames}
      >
        <div ref={nodeRef}>{children}</div>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default ModalTransition;
